import { ExexuteCommand } from "../../../modules/solarGridControl/types";
import api from "../api-instance";

const ROUTE = "/Commands";

export async function executeCommand(usina: ExexuteCommand) {
  await api.post(`${ROUTE}/execute`, usina);
}
